export const Status = Object.freeze({
    NEW: 1,
    ENROLLING: 2,
    PAUSED: 3,
    DONE: 4,
    STOPPED: 5,
    FAILED: 6
});
